import * as Zod from 'zod';

import { translate } from 'utils/i18n';
import { fileValidator } from 'common/validators/file';

export function getLocationFormValidator() {
    return Zod.object({
        title: Zod.string(translate('validate.required')).nonempty(
            translate('validate.required')
        ),
        address: Zod.string(translate('validate.required')).nonempty(
            translate('validate.required')
        ),
        description: Zod.string(),
        image: fileValidator.optional().nullable(),
    });
}
